export default __webpack_public_path__ + "static/media/arrw.18982e91.svg";